export enum SupoTypeEnum {
  BATCH = 'BATCH',
  NORMAL = 'NORMAL',
  BLACKLIST = 'BLACKLIST',
  PARTNER = 'PARTNER',
  MEDICAL_ESCORT = 'MEDICAL_ESCORT'
}
